// src/components/DeleteSelectionGroupModal/DeleteSelectionGroupModal.tsx

import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { DeleteSelectionModifier } from '../../../../../../../../crud/menu_api/selection_modifiers';
import { toast } from 'react-toastify';

interface SelectionModifierType {
    readonly modifier_id: number;
    modifier_name: string;
    modifier_description?: string;
    local_id: number;
    items_affected: Array<{
        item_id: number;
        item_name: string;
    }>;
    options_included: Array<{
        option_id: number;
        option_name: string;
    }>;
}

interface DeleteSelectionGroupModalProps {
  show: boolean;
  handleClose: () => void;
  mod: SelectionModifierType;
  setModifiers: (data: SelectionModifierType[]) => void;
  modifiers: SelectionModifierType[];
}

const DeleteModifierModal: React.FC<DeleteSelectionGroupModalProps> = ({
  show,
  handleClose,
  mod,
  setModifiers,
  modifiers,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = () => {
    setLoading(true);
    DeleteSelectionModifier(mod.modifier_id)
      .then((response) => {
        toast.success('Grupo de selección eliminado exitosamente.');
        // Filtrar el grupo eliminado de la lista
        const updatedData = modifiers.filter(
          (modi) => modi.modifier_id !== mod.modifier_id
        );
        setModifiers(updatedData);
        handleClose();
      })
      .catch((error) => {
        console.error('Error eliminando el grupo de selección', error);
        const message =
          error.response?.data?.message || 'Error al eliminar el grupo de selección.';
        toast.error(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header >
        <Modal.Title>Eliminar Grupo de Selección</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          ¿Estás seguro de que deseas eliminar el grupo de modificadores{' '}
          <strong>{mod.modifier_name}</strong>?
        </p>
        
        <p>
          Esta acción no se puede deshacer y se eliminarán todas las opciones asociadas a este
          grupo.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              Eliminando...
            </>
          ) : (
            'Eliminar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModifierModal;
